import { render, staticRenderFns } from "./DateComponent.vue?vue&type=template&id=1ec681c5&scoped=true&"
import script from "./DateComponent.vue?vue&type=script&lang=ts&"
export * from "./DateComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec681c5",
  null
  
)

export default component.exports